import styled from "styled-components";

import { Icon } from "@formant/ui/component/common/Icon";

import { TeleopModule } from "..";
import { FitFill } from "../../../common/FitFill";

export const TeleopScreenModule = styled(TeleopModule)`
    display: flex;
    align-items: center;
    justify-content: center;
    touch-action: none;
    background: var(--formant-color-background);
    cursor: pointer;
    height: 100%;
    width: 100%;
`;

export const Container = styled(FitFill)`
    background-color: black;
    width: 100%;
    height: 100%;
`;

export const ImageDisplay = styled.img`
    z-index: 0;
`;

export const NoSignal = styled.div`
    display: flex;
    align-items: center;
    color: var(--formant-color-primary-silver);
`;

export const NoSignalIcon = styled(Icon)`
    margin-right: 0.625rem;
`;
